export class UpdateReportError extends Error {
	public errors: Array<string>;

	constructor(errors: Array<string>) {
		super(errors[0]);
		this.errors = errors;
	}
}
